const Category = () => (
  <>
    <h1>Category Page.</h1>
  </>
);

export default Category;
